import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { map } from 'rxjs/operators'

@Injectable()
export class UserService {
    constructor(public http: HttpClient) { }

    canFastTrack(): Promise<boolean>  {
        //need to get thos from the .net claim
        return this.http.get('/Users/AuthedUser').toPromise().then((res: any) => {
          switch (res?.Role) {// there can only be one role
          case "Admin":
            return false;
          case "citipostadmin":
            return false;
          case "citipostsuperadmin":
            return true;
          case "specsaversadmin":
              return true;
            case "specsaverslogistics":
              return true;
          case "Store":
            return false;
          case "User":
            return false;
          default:
            return false;
          }
        });
    }


    iscitipostsuperadminOnly(redirect:boolean = true): Promise<boolean>  {
        return this.http.get('/Users/AuthedUser').toPromise().then((res: any) => {
            if ((res?.Role === "citipostsuperadmin")) {
                //localStorage.setItem("User", res.User);
                //localStorage.setItem("Role", res.Role);
                return true;
            }
            else {
                if (redirect) {
                    //localStorage.clear();
                    window.location.href = "/";
                }//redirect on the canactivate route guards
                return false;
            }
        });
    }

    isCitipostOnly(redirect: boolean = true): Promise<boolean>  {
        return this.http.get('/Users/AuthedUser').toPromise().then((res: any) => {
            if ( (res?.Role === "citipostsuperadmin") || (res?.Role === "citipostadmin")) {
                //localStorage.setItem("User", res.User);
                //localStorage.setItem("Role", res.Role);
                return true;
            }
            else {
                if (redirect) {
                   // localStorage.clear();
                    window.location.href = "/";
                }//redirect on the canactivate route guards
                return false;
            }
        });
    }


    isSuperAdmin(redirect: boolean = true): Promise<boolean>  {
        return this.http.get('/Users/AuthedUser').toPromise().then((res: any) => {
            if ((res?.Role === "citipostsuperadmin")) {
                //localStorage.setItem("User", res.User);
                //localStorage.setItem("Role", res.Role);
                return true;
            }
            else {
                if (redirect) {
                    //localStorage.clear();
                    window.location.href = "/";
                }//redirect on the canactivate route guards
                return false;
            }
        });
  }





    public loggedInAs() {
      return this.http.get('/Users/AuthedUser').pipe(map((res: any) => { if (res?.Role === 'Store') { return "You are logged in as a Store"; }  else { return res?.Firstname + ' ' + res?.Lastname; }  }));
    }

    public welcome() {
      return this.http.get('/Users/AuthedUser').pipe(map((res: any) => { return res?.Firstname + ' ' + res?.Lastname + ' (' + res?.Role + ')'; }));
    }

    public role() {
      return this.http.get('/Users/AuthedUser').pipe(map((res: any) => { return res?.Role; }));
    }

    public canSend() {
      return this.http.get('/Users/AuthedUser').pipe(map((res: any) => { return res?.Role === "citipostsuperadmin"; }));
    }

    public profile() {
      return this.http.get('/Users/AuthedUser').pipe(map((res: any) => { return res ; }));
    }


}
